// extracted by mini-css-extract-plugin
export default {"SignContainer":"LogIn_SignContainer__dtu1N","Sign":"LogIn_Sign__dNgP+","SignForm":"LogIn_SignForm__FsKK6","sup":"LogIn_sup__Ys4HL","hal":"LogIn_hal__qF5gR","don":"LogIn_don__o-r72"};